import * as React from "react";
const SvgFiBrandsGoodreads = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 25 24"
    {...props}
  >
    <g clipPath="url(#fi-brands-goodreads_svg__a)">
      <path
        fill="#151A2D"
        d="M16.735 8.529c.285 1.998-.262 4.232-2.003 5.395-1.244.83-2.947.755-3.95.305-2.07-.927-2.763-3.139-2.612-5.207.24-3.263 2.282-4.709 4.202-4.688 2.617-.011 4.006 1.704 4.363 4.195M25 3v18c0 1.655-1.401 3-3.125 3H3.125C1.401 24 0 22.655 0 21V3c0-1.655 1.401-3 3.125-3h18.75C23.599 0 25 1.345 25 3m-6.584 12.064s-.006-1.821-.006-11.641h-1.618v2.159c-.045.016-.067-.027-.09-.064-.535-1.109-2.003-2.48-4.24-2.464-2.896.021-4.866 1.671-5.614 4.168-.24.798-.325 1.612-.307 2.442.094 4.173 2.516 6.311 6.272 6.171 1.612-.059 3.041-.911 3.85-2.421.028-.054.061-.102.094-.155.012.005.022.005.034.011.016.204.011 1.645.005 1.848-.012.793-.112 1.58-.402 2.33-.436 1.125-1.245 1.859-2.484 2.116-.993.209-1.986.204-2.968-.064-1.2-.327-2.037-1.018-2.294-2.239-.017-.086-.073-.07-.128-.07H7.026c.045.568.178 1.087.474 1.564 1.35 2.17 4.615 2.598 7.154 2.004 2.785-.659 3.755-2.941 3.762-5.695"
      />
    </g>
    <defs>
      <clipPath id="fi-brands-goodreads_svg__a">
        <path fill="#fff" d="M0 0h25v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsGoodreads;
